import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEstablecimientosTipoO } from "../../../../redux/actions/establecimiento";
import {
  getDatosEstablecimiento,
  postDependenciaEmpleador,
  postUbicacionForm,
  validarCargaNuevaObra
} from "../../../../redux/actions/obra";
import { convertDateTimeToNet } from "../../../../util/datetime";
import CircularLoading from "../../../commons/loading/CircularLoading";
import UbicacionForm from "./UbicacionForm";

const initialValues = {
  idDependenciaEmpleador: null,
};

const UbicacionContainer = ({ nextForm, lastFormProps }) => {
  const dispatch = useDispatch();
  const establecimientos = useSelector(
    (state) => state.establecimiento.establecimientosTipoO.data
  );
  const datosEstablecimiento = useSelector(
    (state) => state.obra.datosEstablecimiento.data
  );
  const ubicacion = useSelector((state) => state.obra.postNuevaObra.ubicacion);
  const identificacion = useSelector((state) => state.obra.postNuevaObra.identificacion);

  const [formModel, setFormModel] = useState();

  const [openEstablecimientoDialog, setOpenEstablecimientoDialog] =
    useState(false);

  const handleSumbitNewEstablecimiento = (values, setFieldValue) => {
    let valuesToPost = {
      ...values,
      tipoEstablecimiento: "O",
      principal: false,
      temporal: true,
      nro: !values.km && parseInt(values.numero),
      altura: values.km && parseFloat(values.numero.replace(",", ".")),
    };

    if (values.km) {
      delete valuesToPost.nro;
    } else {
      delete valuesToPost.altura;
    }

    dispatch(postDependenciaEmpleador(valuesToPost)).then((res) => {
      setOpenEstablecimientoDialog(false);
      dispatch(getEstablecimientosTipoO()).then(() => {
        setFieldValue("idDependenciaEmpleador", res.value.data);
        dispatch(getDatosEstablecimiento(res.value.data));
      });
    });
  };

  useEffect(() => {
    if (establecimientos.length === 0 || lastFormProps?.idGestionObra) {
      dispatch(getEstablecimientosTipoO()).finally(() => {
        if (ubicacion.idDependenciaEmpleador) {
          dispatch(getDatosEstablecimiento(ubicacion.idDependenciaEmpleador));
        }
        if (Object.keys(ubicacion).length > 0) {
          setFormModel({
            ...ubicacion,
            fechaInicioObra: identificacion.fechaInicioObra,
          });
        } else {
          setFormModel({
            ...initialValues,
            fechaInicioObra: identificacion.fechaInicioObra,
          });
        }
      })
    } else {
      if (Object.keys(ubicacion).length > 0) {
        setFormModel({
          ...ubicacion,
          fechaInicioObra: identificacion.fechaInicioObra,
        });
      } else {
        setFormModel({
          ...initialValues,
          fechaInicioObra: identificacion.fechaInicioObra,
        });
      }
    }

  }, [ubicacion]);

  const handleSubmit = (values) => {
    if (lastFormProps?.idGestionObra) {
      dispatch(postUbicacionForm(values));
      nextForm("Tipo de Obra");
    } else {
      dispatch(
        validarCargaNuevaObra({
          ...values,
          fechaFinObra: convertDateTimeToNet(identificacion.fechaFinObra),
          fechaInicioObra: convertDateTimeToNet(identificacion.fechaInicioObra),
        })
      ).then(() => {
        dispatch(postUbicacionForm(values));
        nextForm("Tipo de Obra");
      });
    }
  };

  if (!formModel) {
    return <CircularLoading />;
  }


  return (
    <>
      <UbicacionForm
        establecimientos={establecimientos}
        setOpenEstablecimientoDialog={setOpenEstablecimientoDialog}
        datosEstablecimiento={datosEstablecimiento}
        openEstablecimientoDialog={openEstablecimientoDialog}
        handleSumbitNewEstablecimiento={handleSumbitNewEstablecimiento}
        handleSubmitUbicacion={handleSubmit}
        formModel={formModel}
        disabled={!!lastFormProps?.idGestionObra}
      />
    </>
  )
};

export default UbicacionContainer;